import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  IconButton,
  TextField,
  Stack,
  Button,
  Select,
  MenuItem,
  FormControl,
  Pagination,
  Tooltip,
} from "@mui/material";
import {
  Edit,
  Delete,
  Search,
  MonetizationOnOutlined,
  AccountBalanceWalletOutlined,
} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useAuth } from "../../../../context";
import useFetchObjects from "../../../../api/useFetchObjects";
import useDelete from "../../../../api/useDelete";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EditExpensePaymentListDialog from "./EditExpensePaymentListDialog";

const ExpensePaymentList = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const token = auth?.user?.token;
  const navigate = useNavigate();

  const [openDialog, setOpenDialog] = useState(false);
  const [currentPayment, setCurrentPayment] = useState(null);
  const [query, setQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [selectedExpenseSource, setSelectedExpenseSource] = useState("");
  const [totalPaid, setTotalPaid] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(0);

  // Pagination States
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPayments, setTotalPayments] = useState(0);

  const { data: sources } = useFetchObjects(
    ["expense-sources"],
    `expense-sources/`,
    token
  );

  const {
    data: payments,
    refetch,
    isLoading,
    isError,
  } = useFetchObjects(
    ["expense-payments", query, dateFilter],
    `expense-payments/?search=${query}&date=${dateFilter}&page=${page}&page_size=${rowsPerPage}`,
    token
  );

  const { handleDelete, ConfirmDialog } = useDelete("expense-payments", token);

  useEffect(() => {
    refetch();
  }, [query, dateFilter, refetch, page, rowsPerPage]);

  useEffect(() => {
    if (payments && typeof payments.count === "number") {
      setTotalPayments(payments.count);
    }
  }, [payments]);

  // useEffect(() => {
  //   if (selectedExpenseSource) {
  //     const expenseSource = sources?.find(
  //       (c) => c.id === selectedExpenseSource
  //     );
  //     if (expenseSource) {
  //       setTotalPaid(expenseSource.total_paid);
  //       setRemainingBalance(expenseSource.remaining_balance);
  //     }
  //   } else {
  //     setTotalPaid(0);
  //     setRemainingBalance(0);
  //   }
  // }, [selectedExpenseSource, sources]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleEditClick = (payment) => {
    setCurrentPayment(payment);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentPayment(null);
  };

  return (
    <Grid container spacing={4} mb={4} pb={5}>
      <Grid item xs={12}>
        <Box
          padding="20px"
          backgroundColor="white"
          boxShadow={2}
          borderRadius={2}
        >
          <Box display="flex" justifyContent="space-between" mb={3}>
            <Typography variant="h6" fontWeight={600} color="primary">
              {t("finance.expensePaymentList")}
            </Typography>
            <Button
              size="small"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate("/finance/expense-payments/add")}
              sx={{
                textTransform: "none",
                fontWeight: "500",
                paddingX: 2,
                paddingY: 1,
                borderRadius: "6px",
                boxShadow: 1,
                transition: "all 0.3s ease",
              }}
            >
              {t("finance.addNew")}
            </Button>
          </Box>

          <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={2}>
            <TextField
              label={t("finance.searchByExpense")}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{ endAdornment: <Search color="action" /> }}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <TextField
              label={t("finance.filterByDate")}
              type="date"
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            />
            {/* <FormControl variant="outlined" size="small" fullWidth>
              <Select
                value={selectedExpenseSource}
                onChange={(e) => setSelectedExpenseSource(e.target.value)}
                displayEmpty
                renderValue={(selected) => {
                  if (selected === "") {
                    return <em>{t("finance.selectExpenseSource")}</em>;
                  }
                  const expenseSource = sources?.find((c) => c.id === selected);
                  return expenseSource ? (
                    expenseSource.name
                  ) : (
                    <em>{t("finance.selectExpenseSource")}</em>
                  );
                }}
              >
                <MenuItem value="">
                  <em>{t("finance.selectExpenseSource")}</em>
                </MenuItem>
                {sources?.map((expenseSource) => (
                  <MenuItem key={expenseSource.id} value={expenseSource.id}>
                    {expenseSource.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
          </Stack>

          {/* Compact Total Paid and Remaining Balance Section */}
          {/* {selectedExpenseSource && (
            <Box mb={3}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={3}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p={1}
                    bgcolor="#f5f5f5"
                    borderRadius={1}
                  >
                    <MonetizationOnOutlined color="primary" fontSize="small" />
                    <Box ml={1}>
                      <Typography variant="caption" color="textSecondary">
                        {t("finance.totalPaid")}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="primary"
                        fontWeight={500}
                      >
                        ؋ {totalPaid?.toLocaleString()}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Box
                    display="flex"
                    alignItems="center"
                    p={1}
                    bgcolor="#f5f5f5"
                    borderRadius={1}
                  >
                    <AccountBalanceWalletOutlined
                      color="error"
                      fontSize="small"
                    />
                    <Box ml={1}>
                      <Typography variant="caption" color="textSecondary">
                        {t("finance.remainingBalance")}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="error"
                        fontWeight={500}
                      >
                        ؋ {remainingBalance?.toLocaleString()}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )} */}

          {isLoading ? (
            <Box textAlign="center" mt={4}>
              <CircularProgress />
              <Typography variant="body2">{t("finance.loading")}</Typography>
            </Box>
          ) : isError ? (
            <Box textAlign="center" color="red" mt={4}>
              <Typography variant="body2">
                {t("finance.errorFetchingData")}
              </Typography>
            </Box>
          ) : (
            <TableContainer
              component={Paper}
              sx={{ boxShadow: 1, borderRadius: 1 }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow style={{ backgroundColor: "#fafafa" }}>
                    <TableCell align="center" width="5%">
                      #
                    </TableCell>
                    <TableCell align="center">
                      {t("finance.amountPaid")}
                    </TableCell>
                    <TableCell align="center">
                      {t("finance.paymentDate")}
                    </TableCell>
                    <TableCell align="center" width="15%">
                      {t("finance.actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payments?.results?.map((payment, index) => (
                    <TableRow key={payment.id}>
                      <TableCell align="center">
                        {(page - 1) * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell align="center">
                        ؋ {payment.amount.toLocaleString()}
                      </TableCell>
                      <TableCell align="center">
                        {new Date(payment.date).toLocaleDateString()}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title={t("finance.edit")}>
                          <IconButton
                            onClick={() => handleEditClick(payment)}
                            color="primary"
                            size="small"
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("finance.delete")}>
                          <IconButton
                            onClick={() => handleDelete(payment.id)}
                            color="error"
                            size="small"
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={3}
          >
            <Box display="flex" alignItems="center">
              <Typography variant="body2" mr={1}>
                {t("finance.rowsPerPage")}:
              </Typography>
              <FormControl variant="outlined" size="large">
                <Select
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  sx={{
                    width: 100,
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                >
                  {[10, 25, 50, 100, 500, 1000].map((rows) => (
                    <MenuItem key={rows} value={rows}>
                      {rows}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Pagination
              count={Math.ceil(totalPayments / rowsPerPage)}
              page={page}
              onChange={handlePageChange}
              variant="outlined"
              color="primary"
              size="small"
              showFirstButton
              showLastButton
            />
          </Box>

          {currentPayment && (
            <EditExpensePaymentListDialog
              open={openDialog}
              onClose={handleCloseDialog}
              payment={currentPayment}
              token={token}
            />
          )}
        </Box>
      </Grid>
      <ConfirmDialog />
    </Grid>
  );
};

export default ExpensePaymentList;
